module.exports = __webpack_public_path__ + "static/media/data-error-icon2.fccff7d2.svg";